import { render, staticRenderFns } from "./udiCheckReview.vue?vue&type=template&id=c7fc87b8&scoped=true&"
import script from "./udiCheckReview.vue?vue&type=script&lang=js&"
export * from "./udiCheckReview.vue?vue&type=script&lang=js&"
import style0 from "./udiCheckReview.vue?vue&type=style&index=0&id=c7fc87b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fc87b8",
  null
  
)

export default component.exports